import BackOfficeApp from 'hb-react/backoffice/providers/App';
import {
  ROUTE_TAG_CURRENT_NETWORK,
  ROUTE_TAG_FEATURES,
} from 'hb-react/publicoffice/constants/routeTags';
import PublicOfficeApp from 'hb-react/publicoffice/providers/App';
import useNetworkConfiguration from 'hb-react/publicoffice/utils/useNetworkConfiguration';
import ErrorBoundary from 'hb-react/shared/components/ErrorBoundary';
import GlobalStyle from 'hb-react/style/GlobalStyle';

import CookieBannerApp from './CookieBannerApp';

// Constants to prevent re-creation on every render
const NETWORK_CONFIGURATION_OPTIONS = [
  'payment_gateway',
  'has_payment_account',
  'linked_in_is_enabled',
  'twitter_is_enabled',
  'facebook_is_enabled',
  'has_google_analytics_tracking',
];
const NETWORK_ROUTE_TAGS = [
  {
    routeTag: ROUTE_TAG_CURRENT_NETWORK,
  },
  {
    routeTag: ROUTE_TAG_FEATURES,
    params: { app_names: ['cookies', 'amplitude'] },
  },
];

const CookieBannerAppStandalone = ({ env }) => {
  const ProviderComponent = env === 'bo' ? BackOfficeApp : PublicOfficeApp;

  const { networkConfiguration } = useNetworkConfiguration({
    styleNeeded: false,
    networkConfigurationOptions: NETWORK_CONFIGURATION_OPTIONS,
    networkRouteTags: NETWORK_ROUTE_TAGS,
  });

  if (networkConfiguration) {
    const { colors, theming, networkConfigData, currentNetwork, featuresData } =
      networkConfiguration;

    const customNetwork = {
      features: featuresData?.features,
      colors: colors?.colors,
      network_configuration: networkConfigData,
      theming: theming?.theming,
      id: currentNetwork?.id,
    };

    return (
      <ErrorBoundary app="po" module="cookie_banner">
        <ProviderComponent
          network={customNetwork}
          colors={customNetwork.colors}
        >
          <GlobalStyle />
          <CookieBannerApp env={env} />
        </ProviderComponent>
      </ErrorBoundary>
    );
  }

  return null;
};

export default CookieBannerAppStandalone;
